import { Controller } from "@hotwired/stimulus"

// Auto-submits a form via fetch PATCH con Accept: application/json.
// Uso pensado para los edit forms del editor visual de paginas, donde
// no hay boton "Guardar": cada cambio persiste directo y el iframe
// preview se actualiza via broadcast server-side (PreviewBroadcastable).
//
// Eventos esperados en el form:
//   change -> submitNow          (selects, radios, checkboxes → instantaneo)
//   input  -> submitDebounced    (text fields/textareas → debounce 400ms)
//
// Response JSON no re-renderiza el frame, asi el focus se preserva.
// Al success dispara `editor:record-saved` para que el draft-store
// marque dirty y habilite "Guardar"/"Descartar".
export default class extends Controller {
  static values = { delay: { type: Number, default: 400 } }

  disconnect() {
    clearTimeout(this._timeout)
  }

  submitNow() {
    clearTimeout(this._timeout)
    this.#submit()
  }

  submitDebounced() {
    clearTimeout(this._timeout)
    this._timeout = setTimeout(() => this.#submit(), this.delayValue)
  }

  async #submit() {
    const form = this.element
    const csrf = document.querySelector("meta[name='csrf-token']")?.content
    const response = await fetch(form.action, {
      method: "POST",
      headers: { "Accept": "application/json", "X-CSRF-Token": csrf },
      body: new FormData(form)
    })
    if (response.ok) {
      document.dispatchEvent(new CustomEvent("editor:record-saved", { bubbles: true }))
    }
  }
}
